import { useState } from 'react';
import styled from 'styled-components';
import { MenuRounded, CloseRounded } from '@mui/icons-material';
import NormsyLogo from '../../assets/images/landing/logo-normsy.png';

const LogoWrapper = styled.div`
    max-width: 350px;
`;

const Logo = styled.img`
    height: auto;
    width: 100%;
`;

const Navbar = styled.nav`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding: 1rem 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 10;
`;

const NavLinks = styled.ul`
    list-style: none;
    display: flex;
    gap: 2rem;
    margin: 0;

    li a {
        color: white;
        text-decoration: none;
        font-weight: 500;
        font-size: 1rem;

        &:hover {
            color: #a9d3ff;
        }
    }

    @media (max-width: 768px) {
        display: none;
    }
`;

const MobileMenuIcon = styled.div`
    display: none;
    font-size: 1.5rem;
    color: white;
    cursor: pointer;

    @media (max-width: 768px) {
        display: block;
    }
`;

const Sidebar = styled.div`
  position: fixed;
  top: 0;
  left: ${({ open }) => (open ? '0' : '-250px')};
  width: 250px;
  height: 100vh;
  background: rgba(10, 25, 47, 0.97);
  padding: 2rem 1rem;
  transition: left 0.3s ease-in-out;
  z-index: 100;

  ul {
    list-style: none;
    padding: 0;
    margin-top: 3rem;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  li a {
    color: white;
    text-decoration: none;
    font-size: 1.2rem;

    &:hover {
      color: #a9d3ff;
    }
  }
`;

const NavBar = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <>
            <Navbar>
                <LogoWrapper>
                    <Logo src={NormsyLogo} />
                </LogoWrapper>
                <NavLinks>
                    <li><a href='/'>Home</a></li>
                    <li><a href='/about'>About</a></li>
                    <li><a href={`mailto:info@civichealthproject.org?subject=${encodeURIComponent('Sending an inquiry about Normsy')}`}>Contact</a></li>
                    <li><a href='https://www.civichealthproject.org/donate/' target='_blank' rel='noopener noreferrer'>Donate</a></li>
                    <li><a href='/home'>Login</a></li>
                </NavLinks>

                <MobileMenuIcon onClick={() => setMenuOpen(!menuOpen)}>
                    {menuOpen ? <CloseRounded /> : <MenuRounded />}
                </MobileMenuIcon>
            </Navbar>
            <Sidebar open={menuOpen}>
                <ul>
                    <li><a href='/' onClick={() => setMenuOpen(false)}>Home</a></li>
                    <li><a href='/about' onClick={() => setMenuOpen(false)}>About</a></li>
                    <li><a href={`mailto:info@civichealthproject.org?subject=${encodeURIComponent('Sending an inquiry about Normsy')}`} onClick={() => setMenuOpen(false)}>Contact</a></li>
                    <li><a href='https://www.civichealthproject.org/donate/' target='_blank' rel='noopener noreferrer' onClick={() => setMenuOpen(false)}>Donate</a></li>
                    <li><a href='/home' onClick={() => setMenuOpen(false)}>Login</a></li>
                </ul>
            </Sidebar>
        </>
    );
};

export default NavBar;
